export const renderNodesWithDivider = (nodes, divider) => {
    return nodes.reduce((acc, node, index) => {
        if (index === 0) {
            return [node];
        }
        return [...acc, divider, node];
    }, []);
};
//# sourceMappingURL=render-nodes-with-divider.js.map